var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.primaryEnrolment
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page primaryEnrolment-page",
            attrs: { id: "print_primaryEnrolment" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "font-size": "23px",
                  "text-align": "center",
                  "font-weight": "600",
                },
              },
              [
                _c(
                  "table",
                  {
                    staticStyle: {
                      width: "100%",
                      "border-collapse": "collapse",
                      border: "none",
                      "letter-spacing": "5px",
                    },
                  },
                  [
                    _c("tbody", [
                      _c(
                        "tr",
                        {
                          staticStyle: {
                            width: "100%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.model.primaryEnrolment.hospitalName
                                    ? _vm.model.primaryEnrolment.hospitalName
                                    : ""
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "tr",
                        {
                          staticStyle: {
                            width: "100%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.model.primaryEnrolment.reportName
                                    ? _vm.model.primaryEnrolment.reportName
                                    : "小学入学健康检查表"
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _c("div", [
                  _c("div", [
                    _c("img", {
                      staticStyle: { width: "100%", height: "100%" },
                      attrs: { src: _vm.model.primaryEnrolment.barCodeImage },
                    }),
                  ]),
                  _vm.model.primaryEnrolment.barCodeImage
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "line-height": "0px",
                            "font-size": "15px",
                            "letter-spacing": "0px",
                          },
                        },
                        [_vm._v(_vm._s(_vm.model.primaryEnrolment.barCode))]
                      )
                    : _vm._e(),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "padding-left": "10px",
                  "text-align": "left",
                  width: "100%",
                  "margin-top": "10px",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    {
                      staticStyle: {
                        "line-height": "40px",
                        border: "none",
                        "margin-top": "10px",
                      },
                    },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "25%",
                            border: "none",
                            "margin-top": "10px",
                          },
                          attrs: { colspan: "2" },
                        },
                        [
                          _vm._v("编号： "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.primaryEnrolment.healthCareNumber
                                  ? _vm.model.primaryEnrolment.healthCareNumber
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "45%",
                            border: "none",
                            "margin-top": "10px",
                          },
                          attrs: { colspan: "5" },
                        },
                        [
                          _vm._v("学校："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.primaryEnrolment.schoolName
                                  ? _vm.model.primaryEnrolment.schoolName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: {
                            width: "30%",
                            border: "none",
                            "margin-top": "10px",
                          },
                          attrs: { colspan: "3" },
                        },
                        [
                          _vm._v("班级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.primaryEnrolment.className
                                  ? _vm.model.primaryEnrolment.className
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "text-align": "center",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "1px solid black",
                },
              },
              [
                _c("tbody", [
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("姓名")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.name
                                ? _vm.model.primaryEnrolment.name
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("性别")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.sex
                                ? _vm.model.primaryEnrolment.sex
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("出生日期")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.birthday
                                ? _vm.model.primaryEnrolment.birthday
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2", colspan: "2" },
                      },
                      [_vm._v("既往病史")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "9" },
                      },
                      [
                        _c(
                          "span",
                          {
                            class: {
                              pastMedicalHistory:
                                _vm.model.primaryEnrolment.pastMedicalHistory &&
                                _vm.model.primaryEnrolment.pastMedicalHistory.indexOf(
                                  "1"
                                ) > -1,
                            },
                          },
                          [_vm._v("先天性心脏病      ")]
                        ),
                        _c(
                          "span",
                          {
                            class: {
                              pastMedicalHistory:
                                _vm.model.primaryEnrolment.pastMedicalHistory &&
                                _vm.model.primaryEnrolment.pastMedicalHistory.indexOf(
                                  "2"
                                ) > -1,
                            },
                          },
                          [_vm._v("癫痫      ")]
                        ),
                        _c(
                          "span",
                          {
                            class: {
                              pastMedicalHistory:
                                _vm.model.primaryEnrolment.pastMedicalHistory &&
                                _vm.model.primaryEnrolment.pastMedicalHistory.indexOf(
                                  "3"
                                ) > -1,
                            },
                          },
                          [_vm._v("高热惊厥      ")]
                        ),
                        _c(
                          "span",
                          {
                            class: {
                              pastMedicalHistory:
                                _vm.model.primaryEnrolment.pastMedicalHistory &&
                                _vm.model.primaryEnrolment.pastMedicalHistory.indexOf(
                                  "4"
                                ) > -1,
                            },
                          },
                          [_vm._v("哮喘      ")]
                        ),
                        _c(
                          "span",
                          {
                            class: {
                              pastMedicalHistory:
                                _vm.model.primaryEnrolment.pastMedicalHistory &&
                                _vm.model.primaryEnrolment.pastMedicalHistory.indexOf(
                                  "5"
                                ) > -1,
                            },
                          },
                          [_vm._v("G-6PD缺陷病")]
                        ),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("其他疾病")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.pastMedicalHistoryOther
                                ? _vm.model.primaryEnrolment
                                    .pastMedicalHistoryOther
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("过敏史")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "3" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.allergyHistory
                                ? _vm.model.primaryEnrolment.allergyHistory
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("近期传染病接触史")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "3" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.infectionHistory
                                ? _vm.model.primaryEnrolment.infectionHistory
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "3" },
                      },
                      [_vm._v("儿童家长签字")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.parentConfirmSignature
                                ? _vm.model.primaryEnrolment
                                    .parentConfirmSignature
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _vm._m(0),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("体重")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.weight
                                ? _vm.model.primaryEnrolment.weight
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c("td", [_vm._v("评价")]),
                    _c("td", [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.model.primaryEnrolment.weightEvaluation
                              ? _vm.model.primaryEnrolment.weightEvaluation
                              : ""
                          )
                        ),
                      ]),
                    ]),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("身高")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.height
                                ? _vm.model.primaryEnrolment.height
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c("td", [_vm._v("评价")]),
                    _c("td", [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.model.primaryEnrolment.heightEvaluation
                              ? _vm.model.primaryEnrolment.heightEvaluation
                              : ""
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("眼")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("左眼")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.nakedLeftEyeVision
                                ? _vm.model.primaryEnrolment.nakedLeftEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("耳")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("左耳")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.leftEar
                                ? _vm.model.primaryEnrolment.leftEar
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("口腔")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("牙齿数")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.teethNumber
                                ? _vm.model.primaryEnrolment.teethNumber
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("右眼")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.nakedRightEyeVision
                                ? _vm.model.primaryEnrolment.nakedRightEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("右耳")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.rightEar
                                ? _vm.model.primaryEnrolment.rightEar
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("龋齿数")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.cariesTotalNumber
                                ? _vm.model.primaryEnrolment.cariesTotalNumber
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("头颅")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.head
                                ? _vm.model.primaryEnrolment.head
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("胸廓")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.thorax
                                ? _vm.model.primaryEnrolment.thorax
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("脊柱&四肢")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.spineLimbs
                                ? _vm.model.primaryEnrolment.spineLimbs
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("心肺")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.heart
                                ? _vm.model.primaryEnrolment.heart
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("肝脾")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.liverAndSpleen
                                ? _vm.model.primaryEnrolment.liverAndSpleen
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("外生殖器")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.externalGenitalia
                                ? _vm.model.primaryEnrolment.externalGenitalia
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("皮肤")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "5" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.skin
                                ? _vm.model.primaryEnrolment.skin
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("咽部")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.pharynx
                                ? _vm.model.primaryEnrolment.pharynx
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("其他")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "8" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment
                                .otherPhysicalExamination
                                ? _vm.model.primaryEnrolment
                                    .otherPhysicalExamination
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _vm._m(1),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("血红蛋白")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "3" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.hemoglobinValue
                                ? _vm.model.primaryEnrolment.hemoglobinValue
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("丙氨酸氨基转移酶")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.alanineAminotransferase
                                ? _vm.model.primaryEnrolment
                                    .alanineAminotransferase
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("其他")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "7" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment
                                .otherAuxiliaryInspection
                                ? _vm.model.primaryEnrolment
                                    .otherAuxiliaryInspection
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "3" },
                      },
                      [_vm._v("检查结果")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "7" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.inspectionResults
                                ? _vm.model.primaryEnrolment.inspectionResults
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "40px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [_vm._v("检查单位盖章")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          height: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _vm.model.primaryEnrolment.sealOfInspectionUnit
                          ? _c("img", {
                              staticStyle: {
                                height: "40px",
                                width: "100px",
                                "object-fit": "contain",
                              },
                              attrs: {
                                src: _vm.model.primaryEnrolment
                                  .sealOfInspectionUnit,
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("医师签名")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          height: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _vm.model.primaryEnrolment.doctorSignature
                          ? _c("img", {
                              staticStyle: {
                                height: "40px",
                                width: "100px",
                                "object-fit": "contain",
                              },
                              attrs: {
                                src: _vm.model.primaryEnrolment.doctorSignature,
                              },
                            })
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("体检日期")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          height: "80px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.primaryEnrolment.physicalDate
                                ? _vm.model.primaryEnrolment.physicalDate
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm.model.primaryEnrolment.remark
                    ? _c("tr", { staticStyle: { "line-height": "40px" } }, [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              width: "100px",
                              "border-collapse": "collapse",
                              border: "1px solid black",
                            },
                            attrs: { colspan: "10" },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.model.primaryEnrolment.remark
                                    ? _vm.model.primaryEnrolment.remark
                                    : ""
                                )
                              ),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "100px",
          "border-collapse": "collapse",
          border: "1px solid black",
        },
        attrs: { rowspan: "7" },
      },
      [_vm._v("体格"), _c("br"), _vm._v("检查")]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "100px",
          "border-collapse": "collapse",
          border: "1px solid black",
        },
        attrs: { rowspan: "2" },
      },
      [_vm._v("辅助"), _c("br"), _vm._v("检查")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }